/* eslint no-nested-ternary: 0 */

import _ from 'lodash';
import angular from 'angular';

class ArtistController {
  /* @ngInject */
  constructor(
    $rootScope,
    $state,
    $stateParams,
    $filter,
    $timeout,
    $window,
    $document,
    HelperService
  ) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = vm.artist.title;
      $rootScope.pageDescription = $filter('plainText')(
        vm.artist.fields.biography && vm.artist.fields.biography.html
          ? vm.artist.fields.biography.html
          : ''
      );

      let folios = vm.artist.fields.folios;

      console.log({ folios });

      if ($stateParams.discipline) {
        folios = folios.sort((folio) => {
          try {
            if (
              folio.fields.discipline.terms[0].slug === $stateParams.discipline
            ) {
              return -1;
            }
            return 1;
          } catch (error) {
            //
          }
          return 0;
        });
      }

      folios = folios.map((folio) => {
        const heroField =
          folio.fields.heroAssets && folio.fields.heroAssets.length
            ? folio.fields.heroAssets
            : folio.fields.assets && folio.fields.assets.length
            ? folio.fields.assets
            : folio.fields.folios[0].fields.heroAssets &&
              folio.fields.folios[0].fields.heroAssets.length
            ? folio.fields.folios[0].fields.heroAssets
            : folio.fields.folios[0].fields.assets &&
              folio.fields.folios[0].fields.assets.length
            ? folio.fields.folios[0].fields.assets
            : [];
        folio.hero = HelperService.group(heroField)[0];
        // folio.hero = _.sample(HelperService.group(heroField));
        return folio;
      });

      if (vm.artist.instagramMedia && vm.artist.instagramMedia.length) {
        folios.push({
          schema: 'instagram',
          title: 'Instagram',
          hero: {
            ratio:
              vm.artist.instagramMedia[0].width /
              vm.artist.instagramMedia[0].height,
            entities: [
              {
                schema: 'instagram',
                thumbnail: {
                  thumbnailType: 'proxy',
                  thumbnailUrl: vm.artist.instagramMedia[0].url,
                  ratio:
                    vm.artist.instagramMedia[0].width /
                    vm.artist.instagramMedia[0].height,
                },
              },
            ],
          },
        });
      }

      vm.folios = folios;

      vm.assets = HelperService.group(vm.artist.fields.assets);

      vm.hero = vm.assets[_.random(0, vm.assets.length - 1)];

      if (vm.hero.entities[0].schema === 'video') {
        vm.hero.type = 'video';
        vm.hero.style = 'fill';
      } else {
        vm.hero.type = 'image';

        vm.hero.entities = vm.hero.entities.filter(
          (entity) => entity.schema === 'image'
        );

        if (
          vm.hero.entities.length === 1 &&
          vm.hero.entities[0].thumbnail.ratio >= 1
        ) {
          vm.hero.style = 'fill';
        } else {
          vm.hero.style = 'fit';
        }
      }

      $rootScope.socialImage(
        HelperService.thumbnailSrc(
          vm.hero.entities[0].thumbnail,
          'h:1500;q:80;f:jpg'
        )
      );

      vm.imagesLoadedEvents = {
        done: (event) => {
          angular.element(event.elements[0]).addClass('loaded');

          if (vm.hero.type === 'image') {
            if ($window.scrollY === 0) {
              $timeout(() => {
                if ($window.scrollY === 0) {
                  $document.scrollTo(0, 1);
                }
              }, 2500);
            }
          }
        },
      };

      vm.clickHeading = () => {
        $document.scrollTo(0, 1);
      };

      let playCount = 0;
      vm.onVideoEnded = (event) => {
        playCount += 1;

        if ($window.scrollY === 0 && playCount === 1) {
          $document.scrollTo(0, 1);
        }

        event.target.play();
      };

      vm.hasClientList =
        $filter('plainText')(
          vm.artist.fields.clientList && vm.artist.fields.clientList.html
            ? vm.artist.fields.clientList.html
            : ''
        ) !== '';

      vm.folioUrl = (folio) => {
        if (!folio) {
          return ''; // columnify bug?
        }

        if (folio.schema === 'instagram') {
          return $state.href('index.artist.instagram', {
            artistSlug: vm.artist.slug,
          });
        }

        if (folio.schema === 'folioCollection') {
          return $state.href('index.artist.folioCollection', {
            artistSlug: vm.artist.slug,
            folioCollectionSlug: folio.slug,
          });
        }

        if (folio.fields.assets && folio.fields.assets.length === 1) {
          return $state.href('index.artist.folio', {
            artistSlug: vm.artist.slug,
            folioSlug: folio.slug,
            i: folio.fields.assets[0].id,
          });
        }

        return $state.href('index.artist.folio', {
          artistSlug: vm.artist.slug,
          folioSlug: folio.slug,
        });
      };
    };
  }
}

export default ArtistController;
